module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb-nir.svg?43b61feaa71fe3689833cb76851718a7";